<template functional>
  <div>
    <a href="#" @click="$options.show(props)">{{
      props.row.CustomerQty_INA
    }}</a>
  </div>
</template>

<script>
import store from "../../../../store/index";
export default {
  name: "customerINA",
  show(ops) {
    store.dispatch("getAllCustomerINA", {
      empresaid: ops.row.Empresaid
    });
  }
};
</script>
